import { BaseDataModel } from "@domain/CRM/BaseDataModel";

export class Dropoff extends BaseDataModel {
	name!: string;
	latitude!: number;
	longitude!: number;
	/** MC schedules only active locations. */
	active!: boolean;
	/** Human-readable address shown beside the name. */
	location!: string;
}
